module.exports = __webpack_public_path__ + "static/media/Settings.fa9966d8.svg";